import React from "react";
import StyledModal from "../../../components/CustomModal";
import { FooterButtons, FormWrapper } from "../../../components/styles";
import { AddButton } from "../../Category/styles";
import { Form, Input } from "antd";

interface AddUpdateStickyModalProps {
  handleFormSubmit: (values: any) => void;
  isMarkModalOpen: boolean;
  handleMarkCancel: () => void;
  form: any; // Form instance from antd Form component
  title: string;
  confirmLabel: string;
  loading: boolean;
}

const AddUpdateStickyModal: React.FC<AddUpdateStickyModalProps> = ({ title, confirmLabel, handleFormSubmit, isMarkModalOpen, handleMarkCancel, form, loading }) => {

  return (
    <StyledModal
      draggable={true}
      title={title}
      centered
      open={isMarkModalOpen}
      onCancel={handleMarkCancel}
      footer={
        <FooterButtons>
          <AddButton disabled={loading} onClick={handleMarkCancel}>Cancel</AddButton>
          <AddButton loading={loading} onClick={() => form.submit()} type="primary">
            {confirmLabel}
          </AddButton>
        </FooterButtons>
      }
    >
      <FormWrapper disabled={loading} form={form} name="Update_Sticky" layout="vertical" onFinish={handleFormSubmit}>
        <Form.Item
          name="content"
          label="Escalate Note"
          rules={[
            { required: true, message: "Please write a escalate note." }, // Validation rule
          ]}
        >
          <Input.TextArea rows={4} placeholder="Write a escalate note.." />
        </Form.Item>
      </FormWrapper>
    </StyledModal>
  );
};

export default AddUpdateStickyModal;
